<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35.129"
    height="35.129"
    viewBox="0 0 35.129 35.129"
  >
    <g id="Новинка" transform="translate(0 0)">
      <path
        id="Контур_1608"
        data-name="Контур 1608"
        d="M638.952-162.937c0,1.113-1.9,2.024-2.111,3.075-.214,1.083,1.192,2.652.778,3.649-.42,1.014-2.528,1.127-3.131,2.028s.09,2.9-.681,3.668-2.76.072-3.668.68-1.014,2.711-2.028,3.131c-1,.413-2.565-.992-3.648-.778-1.051.208-1.962,2.111-3.075,2.111s-2.024-1.9-3.075-2.111c-1.083-.214-2.652,1.191-3.648.778-1.014-.421-1.127-2.528-2.029-3.131s-2.9.09-3.668-.681-.072-2.76-.68-3.668-2.711-1.014-3.131-2.029c-.414-1,.992-2.565.778-3.648-.208-1.052-2.111-1.963-2.111-3.075s1.9-2.023,2.111-3.075c.214-1.083-1.192-2.652-.778-3.649.42-1.014,2.528-1.127,3.131-2.029s-.09-2.9.68-3.668,2.76-.072,3.668-.68,1.014-2.71,2.028-3.131c1-.413,2.565.992,3.648.778,1.052-.208,1.962-2.111,3.075-2.111s2.024,1.9,3.075,2.111c1.083.214,2.652-1.191,3.648-.778,1.014.42,1.127,2.528,2.029,3.131s2.9-.09,3.668.68.072,2.76.68,3.668,2.71,1.014,3.131,2.029c.413,1-.993,2.565-.778,3.648C637.049-164.96,638.952-164.049,638.952-162.937Z"
        transform="translate(-603.823 180.501)"
        fill="#ff9800"
      />
      <text
        id="new"
        transform="translate(5.993 22.305)"
        fill="#fff"
        font-size="11"
        font-family="Helvetica-Bold, Helvetica"
        font-weight="700"
      >
        <tspan x="0" y="0">new</tspan>
      </text>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconNew',
  }
</script>
